import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/account/auth.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { MemberSearchService } from '../member-search/member-search.service';
import { Contact } from '../models/contact.model';
import { ContactService } from '../services/contact.service';
import { GlobalService } from '../services/global.service';
import { IdentityService } from '../services/identity.service';

@Component({
    selector: 'app-shared-communication',
    templateUrl: './shared-communication.component.html',
    styleUrls: ['./shared-communication.component.scss'],
    standalone: false
})
export class SharedCommunicationComponent implements OnInit {
  smsArr: Contact[];
  @Input() FullContactsList: Contact[];
  ChurchEmail: boolean = false;
  isLoading: boolean = true;
  ChurchSMS: boolean = false;
  ChurchNotification: boolean = false;
  MessagingFeature: boolean = false;
  subdomain: string = '';
  htmlContent: string;
  ChurchUsers: [];

  constructor(
    public identityService: IdentityService,
    public globalService: GlobalService,
    private _router: Router,
    private contactService: ContactService,
    private tenantService: TenantService,
    private authService: AuthService,
    public memberSearchService: MemberSearchService
  ) {}

  async ngOnInit() {
    this.isLoading = true;
    await this.authService.autoLogin(1);
    this.subdomain = this.tenantService.getTenant();
    this.MessagingFeature = (
      await this.tenantService.getTenantData()
    ).messagingFeature;
  }

  setChurchSMS() {
    if (this.ChurchSMS == false) {
      this.ChurchSMS = true;
      this.ChurchEmail = false;
      this.ChurchNotification = false;      
    } else this.ChurchSMS = false;
  }

  setChurchEmail() {
    if (this.ChurchEmail == false) {
      this.ChurchEmail = true;
      this.ChurchSMS = false;
      this.ChurchNotification = false;      
    } else this.ChurchEmail = false;
  }
  setChurchNotification() {
    if (this.ChurchNotification == false) {
      this.ChurchNotification = true;
      this.ChurchEmail = false;
      this.ChurchSMS = false;
    } else this.ChurchEmail = false;
  }

  MaskPrimary() {
    if (this.subdomain == 'demo') {
      this.memberSearchService.memberArr.forEach((a) =>
        a['primary'] != null
          ? (a['primary'] =
              a['primary'].split(' ')[0] +
              ' ' +
              a['primary'].split(' ')[1][0] +
              'XXXXXXXXX')
          : ''
      );
    }
  }

  GetContacts() {
    this.MaskPrimary();
    // return this.memberSearchService.memberArr.filter(
    //   (a) => a['selected'] == true
    // );
    var list = this.memberSearchService.selectedMembers;
    return list;
  }
}
